export default __webpack_public_path__ + "static/neighbourcare-3f0a16b8cfe6098309dec85c051175ae.png";